'use client'

import * as React from 'react'

import type { PropsWithChildren } from 'react'
import type { SiteSettings } from '@/interfaces/SiteSettings'

interface SiteSettingsContextProviderProps extends PropsWithChildren {
  siteSettings: SiteSettings
}

export const SiteSettingsContext = React.createContext<SiteSettings | null>(null)

export const SiteSettingsContextProvider: React.FC<SiteSettingsContextProviderProps> = ({ siteSettings, children }) => {
  return <SiteSettingsContext.Provider value={siteSettings}>{children}</SiteSettingsContext.Provider>
}
